import React from "react";
import YoutubeVideo from "./youtubeVideo";

interface State {
    showVideo: boolean;
}

interface Props {
    video: YoutubeVideo;
}

/**
 * Displays the alert row.
 */
export default class YoutubeVideoContainer extends React.Component<
    Props,
    State
> {
    constructor(props: Props) {
        super(props);

        this.state = {
            showVideo: false,
        };
    }

    toggleShow = () => {
        this.setState({ showVideo: true });
    };

    render() {
        // the YouTube embedded video frame
        const videoFrame = (
            <iframe
                src={
                    "https://www.youtube-nocookie.com/embed/" +
                    this.props.video.embedCode
                }
                className="youtube-frame"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        );

        const preview = (
            <div
                className="youtube-preview"
                style={{
                    backgroundImage: "url(" + this.props.video.coverImage + ")",
                }}
            >
                <div className="preview-inner">
                    <div>
                    <p>
                        <img
                            className="img-fluid w-25"
                            src="/static/img/logo_youtube.svg"
                            alt="YouTube"
                        />
                    </p>
                    <p className="fw-bold fs-4">Play this video on YouTube</p>
                    <p className="fs-5 mb-0">
                        If you click here, the video is loaded from YouTube.
                    </p>
                    <p className="fs-6 d-none d-md-block">
                        During this, your IP address is sent to YouTube and
                        YouTube might set some cookies.
                    </p>
                    </div>
                </div>
            </div>
        );

        let content: JSX.Element;
        if (this.state.showVideo) {
            content = videoFrame;
        } else {
            content = preview;
        }

        return (
            <div className="youtube-video-container">
                <div className="youtube-video" onClick={this.toggleShow}>
                    {content}
                </div>
            </div>
        );
    }
}
